var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule-page"},[_c('Head',{attrs:{"title":"拍卖规则"}}),_c('Warpper',{attrs:{"top":"40"}},[_c('iframe',{ref:"iframe",staticClass:"rule-iframe",attrs:{"src":_vm.ihtml,"frameborder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }